import {Component, Input} from '@angular/core';

/**
 * A component that renders an SVG icon for "Magnify Remove Outline"
 *
 * @member {string} tooltip ? The tooltip that needs to be displayed on this icon.
 */

@Component({
    selector: 'app-icon-magnify-remove-outline',
    templateUrl: './icon-magnify-remove-outline.component.html',
    styleUrls: ['./icon-magnify-remove-outline.component.scss'],
    standalone: false
})
export class IconMagnifyRemoveOutlineComponent {
  /**
   * Assign a tooltip that needs to be displayed on this icon as soon as the user hovers on it.
   *
   * @param tooltip ? The tooltip that needs to be displayed on this icon.
   */
  @Input() tooltip?: string;
}
